<template>
  <default-layout>
    <router-view></router-view>
  </default-layout>
</template>

<script>
export default {
  name: "FinancialReporting"
};
</script>
